import React from 'react';
import iconify from '../iconify';

const EditIcon = ({customColor, props}) => (
  <svg width="1em" height="1.14em" viewBox="0 0 103.17 103.17" {...props}>
    <rect
      fill={customColor ? customColor : 'currentColor'}
      x="37.81"
      y="9.06"
      width="23.57"
      height="89.04"
      transform="translate(46.78 126.53) rotate(-135)"
    />
    <path
      fill={customColor ? customColor : 'currentColor'}
      d="M78.45,6H102a0,0,0,0,1,0,0V19.13a.79.79,0,0,1-.79.79h-22a.79.79,0,0,1-.79-.79V6A0,0,0,0,1,78.45,6Z"
      transform="translate(144.89 85.9) rotate(-135)"
    />
    <path
      fill={customColor ? customColor : 'currentColor'}
      d="M22.13,97.72,4.67,103A3.62,3.62,0,0,1,.16,98.5l5.3-17.45Z"
    />
  </svg>
);

export default iconify(EditIcon);
